import React, { Component } from "react";
import Card from "../../../components/common/Card";
import CardHeader from "../../../components/common/CardHeader";
import CardBody from "../../../components/common/CardBody";
import CardTitle from "../../../components/common/CardTitle";
import {
  Table,
  TableHead,
  TableRow,
  TableBody,
  TableCell
} from "@mui/material";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Spinner from "react-bootstrap/Spinner";
import PageSpinner from "../../../components/common/spinner/PageSpinner";
import "../../../components/admin/css/common.css";
import sweetAlert, {
  sweetConfirmAlert,
  sweetStatusAlert,
  sweetAlertInfo,
} from "../../../components/common/SweetAlert";
import SimpleReactValidator from "simple-react-validator";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import { LevelService } from "../../../service/manage/subscription/level.service";
import { AssessmentCreditPackService } from "../../../service/manage/exam_subscription/assessCreditPackage.service.js";
import { AssessmentCreditPackPriceService } from "../../../service/manage/exam_subscription/assessCreditPackagePrice.service.js";
import { LevelPriceService } from "../../../service/manage/subscription/level_price.service";
import TimeZoneHandler from "../../../handlers/TimeZoneHandler";
import moment from "moment-timezone";
import config from '../../../helper/config';
import { customerConstants } from "../../../helper/constants.js";
import CheckBoxInline from "../../../components/common/form/CheckBoxInline.js";
import CheckBox from "../../../components/common/form/CheckBox.js";
import { currencyTypeService } from "../../../service/settings/manage/currency_type.service";

const getCustomerFeatureFlag = () => {
  return config.customerConfigs.featureFlag;
};

let addBtnStyle, closeBtnStyle;
const customer = getCustomerFeatureFlag();
switch (customer) {
  case customerConstants.EXO_CUSTOMER1:
    break;
  case customerConstants.EXO_CUSTOMER2:
    closeBtnStyle = {
      color: "var(--maincolor-cmc)",
      backgroundColor: "#E5F5FF",
      borderColor: "transparent",
    };
    addBtnStyle = {
      color: "#fff",
      backgroundColor: "var(--maincolor-cmc)",
      borderColor: "transparent",
    };
    break;
  default:
    break;
}

export default class AssessCreditPackagePrice extends Component {
  constructor(props) {
    super(props);
    this.state = {
      combinedLevels: "",
      isButtonLoading: true,
      showInsertModal: false,
      initialStateValue: "",
      showModal: false,
      isLoading: false,
      isTableDataLoading: true,
      isModified: false,
      selectedStudentId: "",
      selectedStudentTable: "",
      selectedStudent: null,
      search_id: "",
      isStudentsLoading: false,
      isSubmitting: false,
      registration_id: "",
      editVisibility: false,
      addVisibility: false,
      breadcrumb2: null,
      nodeTitle: null,
      flg_list_active: null,
      levelPrices: null,
      levels: "",
      level_id: "",
      name: "",
      credits: "1",
      value: "",
      currency_type: "",
      status: "",
      start_date: "",
      end_date: "2099-12-31 00:00:00",
      userType: "",
      statuses: [
        {
          id: "Active",
          name: "Active",
        },
        {
          id: "Deactive",
          name: "Deactive",
        },
      ],
      currency_types: [
        {
          id: "NMK",
          name: "NMK",
        },
        {
          id: "USD",
          name: "USD",
        },
        {
          id: "EUR",
          name: "EUR",
        },
        {
          id: "CAD",
          name: "CAD",
        },
        {
          id: "AUD",
          name: "AUD",
        },
        {
          id: "GBP",
          name: "GBP",
        },
      ],
      levelPricePrivilege: null,
      form_list_id: "",
      noEndDate: true,
      allCurrencyTypes: [],
      currency_type_id: 1,
    };

    this.createValidationsInstance();
  }

  handleTabChange = (event, newValue) => {
    this.setState({ activeTab: newValue });
  };

  createValidationsInstance() {
    this.validator = new SimpleReactValidator({
      validators: {
        isDecimal: {
          message:
            "Value must be a valid decimal number with up to 2 decimal places.",
          rule: (val, params, validator) => {
            return validator.helpers.testRegex(val, /^\d+(\.\d{1,2})?$/);
          },
        },
        positiveNumber: {
        message: "The :attribute must be a positive number greater than 0.",
        rule: (val, params, validator) => {
          const num = parseFloat(val);
          return !isNaN(num) && num > 0;
        },
      },
      },
    });
  }

  componentDidMount() {
    if (customerConstants.EXO_CUSTOMER2 !== getCustomerFeatureFlag()) {
      const currency_types = [
        {
          id: "PTE",
          name: "PTE",
        },
      ];
      this.setState({ currency_types: currency_types });
    }
    const {
      privilege_add,
      privilege_edit,
      privilege_delete,
      privilege_view,
      breadcrumb2,
      nodeTitle,
      flg_list_active,
      form_list_id,
    } = this.props.props;
    const userType = sessionStorage.getItem("userType");
    const levelPricePrivilege = {
      tabVisibility: userType === "admin",
      addVisibility: privilege_add == "1" && userType === "admin",
      editVisibility: privilege_edit == "1" && userType === "admin",
      deleteVibility: privilege_delete == "1" && userType === "admin",
      viewVisibility:
        (privilege_view == "1" && userType === "admin") ||
        (privilege_view == "1" && userType === "student") ||
        (privilege_view == "1" && userType === "parent"),
      isAdmin: userType === "admin",
      isStudent: userType === "student",
      isParent: userType === "parent",
    };
    this.getVisibilityCheck(privilege_add, privilege_edit);
    this.getAllLevelPrices();
    // this.getAllLevels();
    this.setState({
      breadcrumb2: breadcrumb2,
      nodeTitle,
      flg_list_active,
      userType,
      levelPricePrivilege,
      form_list_id: form_list_id,
    });
    this.getAllCurrencyTypes();
  }

  formatDateForInput = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  getAllLevelPrices() {
    this.setState({ isTableDataLoading: true });
    const mid = 100;
    AssessmentCreditPackPriceService.getAllCreditPackagePrices(mid)
      .then((res) => {
        if (res.success) {
          this.setState({ levelPrices: res.data.credit_package_prices });
        } else {
          sweetStatusAlert(
            "Failed!",
            "Error fetching Level Grades. Please refresh the screen!",
            "error"
          );
        }
      })
      .finally(() => {
        this.setState({
          isTableDataLoading: false,
          isButtonLoading: false
        });
      });
  }

  getVisibilityCheck(privilege_add, privilege_edit) {
    if (privilege_add == "1") {
      this.setState({
        addVisibility: true,
      });
    }
    if (privilege_edit == "1") {
      this.setState({
        editVisibility: true,
      });
    }
  }
  getLevelNameById = (levelId) => {
    const { levels } = this.state;
    const levelsArray = Object.values(levels);
    const level = levelsArray.find((level) => level.level_id === levelId);
    return level ? level.name : "";
  };

  getCurrencyTypeNameById = (currencyTypeId) => {
    const { allCurrencyTypes } = this.state;
    const currencyType = allCurrencyTypes.find(type => type.currency_type_id === parseInt(currencyTypeId));
    return currencyType ? currencyType.name : '';
  };

  submitLevelPrice = () => {
    const initialStateValue = this.state;
    if (
      this.validator.allValid() &&
      this.validator.fieldValid("credits") &&
      this.validator.fieldValid("value")
    ) {
      this.setState({ showInsertModal: false, isLoading: true });
      const mid = 100;
      const session_id = sessionStorage.getItem("manage_user_id");
      const table_log_id = sessionStorage.getItem("table_log_id");

      const {
        name,
        credits,
        value,
        level_id,
        currency_type_id,
        status,
        start_date,
        end_date,
        form_list_id,
      } = this.state;

      let obj = {
        node_mid: mid,
        name: name,
        credits: parseInt(credits),
        value: value,
        currency_type: currency_type_id,
        status: status,
        start_date: start_date,
        end_date: end_date ? end_date : "2099-12-31 00:00:00",
        user_id: session_id,
        user_table_id: table_log_id,
        create_user_id: session_id,
        create_user_table_id: table_log_id,
        form_list_id: form_list_id,
      };

      if (status === "Deactive") {
        sweetConfirmAlert(
          "Submit Confirmation",
          "Do you want to add this Credit Price as Deactive one?",
          "warning"
        ).then((userConfirmed) => {
          if (userConfirmed) {
            AssessmentCreditPackPriceService.createCreditPackagePrice(JSON.stringify(obj))
              .then((res) => {
                if (res.status === 201) {
                  this.setState({ showInsertModal: false });
                  sweetAlertInfo("", "Success!");
                  this.getAllLevelPrices();
                } else {
                  sweetAlertInfo("Failed!", res.message);
                }
              })
              .catch(() => {
                sweetAlertInfo(
                  "Failed!",
                  "Unable to add the Credit Price!"
                );
              })
              .finally(() => {
                // Hide loading indicator
                this.setState({ isLoading: false });
              });
          } else {
            // User clicked "No"
            sweetAlertInfo("", "Action cancelled!");
            this.setState({ isLoading: false });
          }
        }).catch(() => {
          // Handle any error from sweetConfirmAlert
          this.setState({ isLoading: false });
        });
      } else {
        AssessmentCreditPackPriceService.createCreditPackagePrice(JSON.stringify(obj))
          .then((res) => {
            if (res.status === 201) {
              this.setState({ showInsertModal: false });
              sweetAlertInfo("", "Success!");
              this.getAllLevelPrices();
            } else {
              sweetAlertInfo("Failed!", res.message);
            }
          })
          .catch(() => {
            sweetAlertInfo(
              "Failed!",
              "Unable to add the Credit Price!"
            );
          })
          .finally(() => {
            // Hide loading indicator
            this.setState({ isLoading: false });
          });
      }
    } else {
      this.validator.showMessages();
      this.forceUpdate();
    }
  };

  updateLevelPrice = () => {
    const initialStateValue = this.state;
    if (
      this.validator.allValid()
    ) {
      this.setState({ showModal: false, isLoading: true });
      const {
        name,
        credits,
        value,
        level_id,
        currency_type_id,
        status,
        start_date,
        end_date,
        level_price_id,
        form_list_id,
      } = this.state;
      const mid = 100;
      const session_id = sessionStorage.getItem("manage_user_id");
      const table_log_id = sessionStorage.getItem("table_log_id");

      let obj = {
        node_mid: mid,
        name: name,
        credits: credits,
        value: value,
        currency_type: currency_type_id,
        status: status,
        start_date: start_date,
        end_date: end_date ? end_date : "2099-12-31 00:00:00",
        user_id: session_id,
        user_table_id: table_log_id,
        form_list_id: form_list_id,
      };
      if (initialStateValue !== "Active" && status === "Deactive") {
        sweetConfirmAlert(
          "Update Confirmation",
          "Do you want to update this Credit Price to Deactive?",
          "warning"
        ).then((userConfirmed) => {
          if (userConfirmed) {
            AssessmentCreditPackPriceService.updateCreditPackagePrice(JSON.stringify(obj), level_price_id)
              .then((res) => {
                if (res.status === 200) {
                  this.setState({ showModal: false });
                  this.getAllLevelPrices();
                  sweetAlertInfo("", "Success!");
                } else {
                  sweetAlertInfo("", "Failed!");
                }
              })
              .catch(() => {
                sweetAlertInfo(
                  "Failed!",
                  "Unable to update the Credit Price!",
                );
              })
              .finally(() => {
                // Hide loading indicator
                this.setState({ isLoading: false });
              });
          } else {
            // User clicked "No"
            sweetAlertInfo("", "Action cancelled!");
            this.setState({ isLoading: false });
          }
        }).catch(() => {
          this.setState({ isLoading: false });
        });
      } else {
        AssessmentCreditPackPriceService.updateCreditPackagePrice(JSON.stringify(obj), level_price_id)
          .then((res) => {
            if (res.status === 200) {
              this.setState({ showModal: false });
              this.getAllLevelPrices();
              sweetAlertInfo("", "Success!");
            } else {
              sweetAlertInfo("", "Failed!");
            }
          })
          .catch(() => {
            sweetAlertInfo(
              "Failed!",
              "Unable to update the Credit Price!"
            );
          })
          .finally(() => {
            this.setState({ isLoading: false });
          });
      }
    } else {
      this.validator.showMessages();
      this.forceUpdate();
    }
  };

  deleteLevelPrice = (level_price_id) => {
    sweetConfirmAlert(
      "Are you sure?",
      "Do you want to delete this Credit Price?",
      "warning"
    ).then(() => {
      this.setState({ isLoading: true });
      AssessmentCreditPackPriceService.deleteCreditPackagePrice(
        level_price_id,
        this.state.form_list_id
      )
        .then((res) => {
          if (res.status === 200) {
            this.setState({ showModal: false });
            this.getAllLevelPrices();
            sweetStatusAlert("Success! Please make sure to have an Active valid credit price inorder to show packages to users", res.message.success, "success");
          } else if (res.status === 400) {
            sweetAlertInfo(
              "",
              "Cannot delete Credit Price. This Credit Price already in use.",
            );
          } else {
            sweetStatusAlert("Failed!", res.message, "error");
          }
        })
        .catch(() => {
          sweetStatusAlert(
            "Failed !",
            "Unable to delete the Credit Price!",
            "error"
          );
        })
        .finally(() => {
          // Hide loading indicator
          this.setState({ isLoading: false });
        });
    });
  };

  handleSweetAlert = (toggleFunction, modalVisibility) => {
    if (this.state.isModified) {
      sweetAlert().then((response) => {
        this.validator.purgeFields();
        this.validator.hideMessages();
        this.setState(() => ({
          [modalVisibility]: response,
          isModified: false,
        }));
      });
    } else {
      this.validator.purgeFields();
      this.validator.hideMessages();
      toggleFunction();
    }
  };

  handleChange = (event) => {
    const { name, value } = event.target;
    let creditsError = "";
    let valueError = "";
    let dateError = "";

    let newValue = value;
    if (name === "noEndDate") {
      newValue = value === true || value === "true";
      if (!newValue) {
        this.setState({ end_date: "2099-12-31 00:00:00" });
      } else {
        this.setState({ end_date: "" });
      }
    }
    
    if (name === "credits") {
      if (value && (parseFloat(value) <= 0 || isNaN(parseFloat(value)))) {
        return;
      }
    }
    if (name === "value") {
      if (parseFloat(value) < 0) {
        valueError = "Price value cannot be negative.";
      }
    }

    // Date logic validation
    let startDate = name === "start_date" ? value : this.state.start_date;
    let endDate = name === "end_date" ? value : this.state.end_date;
    let noEndDate = name === "noEndDate" ? value : this.state.noEndDate;

    if (startDate && endDate && newValue) {
      if (new Date(startDate) > new Date(endDate)) {
        dateError = "Start date cannot be after end date.";
      } else if (new Date(endDate) < new Date(startDate)) {
        dateError = "End date cannot be before start date.";
      }
    } else {
      dateError = "";
    }
    this.setState((prevState) => ({
      [name]: value,
      isModified: true,
      creditsError: name === "credits" ? creditsError : prevState.creditsError,
      valueError: name === "value" ? valueError : prevState.valueError,
      dateError: (name === "start_date" || name === "end_date" || name === "noEndDate") ? dateError : prevState.dateError,
    }));
    if (name === "start_date" &&  newValue) {
      const endDateInput = document.querySelector('[name="end_date"]');
      if (endDateInput) {
        endDateInput.min = value;
      }
    }
  };

  toggleAddLevelPriceModal = () => {
    this.setState(
      (prevState) => ({
        showInsertModal: !prevState.showInsertModal,
        name: "",
        level_id: "",
        credits: "1",
        value: "",
        currency_type: "",
        status: "",
        start_date: "",
        // end_date: "",
      }),
      () => { }
    );
  };

  toggleUpdateLevelPriceModal = (LevelPrice) => {
    this.setState({ initialStateValue: LevelPrice.status });
    this.setState(
      (prevState) => ({
        showModal: !prevState.showModal,
        name: "",
        level_id: "",
        credits: "",
        value: "",
        currency_type: "",
        status: "",
        start_date: "",
        end_date: "",
      }),
      () => {
        if (this.state.showModal) {
          this.setState({
            level_price_id: LevelPrice.credit_package_price_id,
            name: LevelPrice.name,
            level_id: LevelPrice.level_id,
            credits: LevelPrice.credits,
            value: LevelPrice.value,
            currency_type: LevelPrice.currency_type,
            status: LevelPrice.status,
            start_date: LevelPrice.start_date,
            end_date: LevelPrice.end_date,
            noEndDate: LevelPrice.end_date !== "2099-12-31 00:00:00",
          });
        }
      }
    );
  };

  convertTimeLevel(utcDateString) {
    const userTimeZone = moment.tz.guess();
    const convertedDate = moment(utcDateString).tz(userTimeZone);

    const formattedDate = convertedDate.format("MMMM D, YYYY h:mm:ss a");

    return formattedDate;
  }

  noEndDateSelected = (e, status) => {
    if (status) {
      this.setState({ noEndDate: status, end_date: "" });
    } else {
      this.setState({ noEndDate: status, end_date: "2099-12-31 00:00:00" });
    }
  };

  getAllCurrencyTypes = async () => {
    try {
      const response = await currencyTypeService.getAllCurrencyTypes();
      if (response.success) {
        this.setState({
          allCurrencyTypes: response.data.currency_types
        });
      } else {
        sweetStatusAlert(
          "Failed!",
          "Error fetching currency types. Please refresh the screen!",
          "error"
        );
      }
    } catch (error) {
      sweetStatusAlert(
        "Failed!",
        "Error fetching currency types. Please refresh the screen!",
        "error"
      );
    }
  };

  handleChangeCurrencyType = (event) => {
    const { value } = event.target;
    this.setState(() => ({ currency_type_id: value, isModified: true }));
  };

  render() {
    const {
      isLoading,
      isTableDataLoading,
      isButtonLoading,
      editVisibility,
      levelPrices,
      name,
      level_id,
      credits,
      value,
      initialStateValue,
      levels,
      currency_type,
      status,
      start_date,
      end_date,
      statuses,
      currency_types,
      levelPricePrivilege,
      noEndDate,
      combinedLevels,
    } = this.state;
    this.validator.purgeFields();

    return (
      <>
        <Card>
          <CardHeader>
            <div>
              <CardTitle cardLabel={"Credit Prices"} />
            </div>
            <div style={{ display: "flex", alignItems: "center" }}>
              {levelPricePrivilege?.addVisibility && (
                <Button
                  className="insert-btn"
                  variant="primary"
                  onClick={this.toggleAddLevelPriceModal}
                >
                  Add Credit Price
                </Button>
              )}
            </div>
          </CardHeader>
          <CardBody>
            {isLoading && (
              <PageSpinner id="show" text="Loading, Please wait!" />
            )}
            {isTableDataLoading ? (
              <div className="loading-container">
                <Spinner animation="border" role="status">
                  <span className="sr-only">Loading...</span>
                </Spinner>
              </div>
            ) : (
              <div style={{ overflow: "Auto" }}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell
                        className="thead"
                        style={{ textAlign: "center" }}
                      >
                        Credit Price Id
                      </TableCell>
                      <TableCell
                        className="thead"
                        style={{ textAlign: "center" }}
                      >
                        Name
                      </TableCell>
                      <TableCell
                        className="thead"
                        style={{ textAlign: "center" }}
                      >
                        Credit
                      </TableCell>
                      <TableCell
                        className="thead"
                        style={{ textAlign: "center" }}
                      >
                        Value
                      </TableCell>
                      <TableCell
                        className="thead"
                        style={{ textAlign: "center" }}
                      >
                        Currency Type
                      </TableCell>
                      <TableCell
                        className="thead"
                        style={{ textAlign: "center" }}
                      >
                        Status
                      </TableCell>
                      <TableCell
                        className="thead"
                        style={{ textAlign: "center" }}
                      >
                        Start Date
                      </TableCell>
                      <TableCell
                        className="thead"
                        style={{ textAlign: "center" }}
                      >
                        End Date
                      </TableCell>
                      {(levelPricePrivilege.addVisibility ||
                        levelPricePrivilege.editVisibility ||
                        levelPricePrivilege.deleteVibility) && (
                          <TableCell
                            className="thead"
                            style={{ textAlign: "center" }}
                          >
                            Actions
                          </TableCell>
                        )}
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {!(Array.isArray(levelPrices) && levelPrices?.length > 0) && (
                      <TableRow>
                        <TableCell colSpan={9} style={{ textAlign: "center" }}>
                          No data available
                        </TableCell>
                      </TableRow>
                    )}
                    {levelPrices?.length > 0 &&
                      levelPrices.map((levelPrice) => (
                        <TableRow key={levelPrice.credit_package_price_id}>
                          <TableCell
                            className="tData"
                            style={{ textAlign: "center" }}
                          >
                            {levelPrice.credit_package_price_id}
                          </TableCell>
                          <TableCell
                            className="tData"
                            style={{ textAlign: "center" }}
                          >
                            {levelPrice.name}
                          </TableCell>
                          <TableCell
                            className="tData"
                            style={{ textAlign: "center" }}
                          >
                            {levelPrice.credits}
                          </TableCell>
                          <TableCell
                            className="tData"
                            style={{ textAlign: "center" }}
                          >
                            {levelPrice.value}
                          </TableCell>
                          <TableCell
                            className="tData"
                            style={{ textAlign: "center" }}
                          >
                            {this.getCurrencyTypeNameById(levelPrice.currency_type)}
                          </TableCell>
                          <TableCell
                            className="tData"
                            style={{ textAlign: "center" }}
                          >
                            {levelPrice.status}
                          </TableCell>
                          <TableCell
                            className="tData"
                            style={{ textAlign: "center" }}
                          >
                            {new Date(
                              this.convertTimeLevel(levelPrice.start_date)
                            ).toLocaleDateString("en-US", {
                              year: "numeric",
                              month: "numeric",
                              day: "numeric",
                            })}
                          </TableCell>

                          <TableCell
                            className="tData"
                            style={{ textAlign: "center" }}
                          >
                            {new Date(
                              this.convertTimeLevel(levelPrice.end_date)
                            ).toLocaleDateString("en-US", {
                              year: "numeric",
                              month: "numeric",
                              day: "numeric",
                            })}
                          </TableCell>

                          {(levelPricePrivilege.addVisibility ||
                            levelPricePrivilege.editVisibility ||
                            levelPricePrivilege.deleteVibility) && (
                              <TableCell
                                className="tData"
                                style={{ textAlign: "center" }}
                              >
                                <div className="btn-group">
                                  {levelPricePrivilege.editVisibility && (
                                    <Button
                                      className="btn btn-icon btn-primary btn-sm m-1 edit-assement-btn flaticon-edit-icon"
                                      title="Edit Details"
                                      onClick={() =>
                                        this.toggleUpdateLevelPriceModal(
                                          levelPrice
                                        )
                                      }
                                    />
                                  )}
                                  {/* {levelPricePrivilege.deleteVibility && (
                                    <Button
                                      className="btn btn-icon btn-danger btn-sm m-1 flaticon-delete"
                                      title="Delete Details"
                                      onClick={() =>
                                        this.deleteLevelPrice(
                                          levelPrice.credit_package_price_id
                                        )
                                      }
                                    />
                                  )} */}
                                </div>
                              </TableCell>
                            )}
                        </TableRow>
                      ))}
                  </TableBody>
                </Table>
              </div>
            )}
          </CardBody>
        </Card>

        <Modal
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          show={this.state.showInsertModal}
          onHide={() => {
            this.setState({
              showInsertModal: false,
              creditsError: "",
              valueError: "",
              dateError: "",
              isModified: false,
            });
            this.validator.purgeFields();
            this.validator.hideMessages();
          }
        }
        >
          <Modal.Header closeButton>
            <Modal.Title>Add Credit Price</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              {/* Row 1: Name + Status */}
              <Row className="my-5">
                <Form.Group as={Col} md="6" controlId="exampleForm.ControlInput1">
                  <Form.Label>Name*</Form.Label>
                  <Form.Control
                    type="text"
                    name="name"
                    defaultValue={name}
                    placeholder="Name"
                    onChange={this.handleChange}
                  />
                  <div style={{ color: "red" }}>
                    {this.validator.message("name", name, "required")}
                  </div>
                </Form.Group>

                <Form.Group as={Col} md="6" controlId="exampleForm.ControlInput1">
                  <Form.Label>Status*</Form.Label>
                  <Form.Select
                    aria-label="Default select example"
                    name="status"
                    onChange={this.handleChange}
                    value={status}
                  >
                    <option value="">Select</option>
                    {statuses.map((singleStatus) => (
                      <option key={singleStatus.id} value={singleStatus.name}>
                        {singleStatus.name}
                      </option>
                    ))}
                  </Form.Select>
                  <div style={{ color: "red" }}>
                    {this.validator.message("status", status, "required")}
                  </div>
                </Form.Group>
              </Row>

              {/* Row 2: Credits + Currency Type + Value */}
              <Row className="my-5">
                <Form.Group as={Col} md="5" controlId="exampleForm.ControlInput1">
                  <Form.Label>Credits*</Form.Label>
                  <Form.Control
                    type="number"
                    name="credits"
                    min="1"
                    value={parseInt(credits)}
                    placeholder="Credits"
                    onChange={this.handleChange}
                    />
                    <div style={{ color: "red" }}>
                    {this.validator.message("credits", credits, ["required", "numeric", {min_num: 1}])}
                    </div>
                </Form.Group>

                <Col md={7}>
                  <Form.Group md="12" controlId="exampleForm.ControlInput1">
                    <Form.Label>Currency Type and Value*</Form.Label>
                    <div style={{ display: 'flex', gap: '0px', alignItems: 'center' }}>
                      <Form.Select
                        id="currency_types"
                        name="currency_type"
                        value={this.state.currency_type_id}
                        onChange={this.handleChangeCurrencyType}
                        className="form-control"
                        style={{
                          borderTopRightRadius: 0,
                          borderBottomRightRadius: 0,
                          width: '25%',
                        }}
                      >
                        <option value="">Select</option>
                        {this.state.allCurrencyTypes.map((option) => (
                          <option key={option.currency_type_id} value={option.currency_type_id}>
                            {option.name}
                          </option>
                        ))}
                      </Form.Select>

                      <Form.Control
                        type="number"
                        name="value"
                        min="0"
                        value={value}
                        placeholder="Value"
                        onChange={this.handleChange}
                        style={{
                          borderTopLeftRadius: 0,
                          borderBottomLeftRadius: 0,
                          width: '75%',
                        }}
                      />
                    </div>
                    <div style={{ color: "red", marginTop: '4px' }}>
                      {this.state.valueError && <p>{this.state.valueError}</p>}
                      {this.validator.message("value", value, ["required", "isDecimal", "min:0"])}
                    </div>
                  </Form.Group>
                </Col>
              </Row>

              {/* Row 3: Start Date + Checkboxes + End Date */}
              <Row className="my-5">
                <Form.Group as={Col} md="4" controlId="exampleForm.ControlInput1">
                  <Form.Label>start Date*</Form.Label>
                  <Form.Control
                    type="date"
                    name="start_date"
                    defaultValue={start_date}
                    placeholder="start date"
                    onChange={this.handleChange}
                  />
                  <div style={{ color: "red" }}>
                    {this.validator.message("start_date", start_date, "required")}
                  </div>
                </Form.Group>

                <Form.Group as={Col} md="4" controlId="noEndDate" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                  <Form.Label>Set end date?</Form.Label>
                  <CheckBoxInline style={{ alignItems: "center" }}>
                    <Form.Label className="mb-0 mr-1" style={{ fontWeight: "500" }}>Yes</Form.Label>
                    <CheckBox
                    onChange={(e) => this.noEndDateSelected(e, true)}                      
                    checked={noEndDate}
                    />
                    <Form.Label className="mb-0 mr-1" style={{ fontWeight: "500" }}>No</Form.Label>
                    <CheckBox
                    onChange={(e) => this.noEndDateSelected(e, false)}                      
                    checked={!noEndDate}
                    />
                  </CheckBoxInline>
                </Form.Group>
                {noEndDate && (
                  <Form.Group as={Col} md="4" controlId="exampleForm.ControlInput1">
                    <Form.Label>End Date*</Form.Label>
                    <Form.Control
                      type="date"
                      name="end_date"
                      min={start_date}
                      defaultValue={end_date}
                      placeholder="end date"
                      onChange={this.handleChange}
                    />
                <div style={{ color: "red" }}>
                  {noEndDate && this.validator.message("end_date", end_date, "required")}
                </div>
                  </Form.Group>
                )}
                {this.state.dateError && (
                  <div style={{ color: "red", marginTop: '4px' }}>{this.state.dateError}</div>
                )}
              </Row>

            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="modal-btn"
              id="modal-close-button"
              style={closeBtnStyle}
              onClick={() => {
                this.setState({
                  showInsertModal: false,
                  creditsError: "",
                  valueError: "",
                  dateError: "",
                  isModified: false,
                });
                this.validator.purgeFields();
                this.validator.hideMessages();
              }}
            >
              Close
            </Button>
            {levelPricePrivilege?.addVisibility && (
              <Button
                className="modal-btn"
                variant="primary"
                style={addBtnStyle}
                onClick={this.submitLevelPrice}
              >
                Save changes
              </Button>
            )}
          </Modal.Footer>
        </Modal>

        <Modal
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          show={this.state.showModal}
          onHide={() => {
            this.setState({
              showModal: false,
              creditsError: "",
              valueError: "",
              dateError: "",
              isModified: false,
            });
            this.validator.purgeFields();
            this.validator.hideMessages();
          }}
        >
          <Modal.Header closeButton>
            <Modal.Title>Update Credit Price</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Row className="my-5">
                <Col md={6}>
                  <Form.Group controlId="exampleForm.ControlInput1">
                    <Form.Label>Name*</Form.Label>
                    <Form.Control
                      type="text"
                      name="name"
                      defaultValue={name}
                      placeholder="Name"
                      onChange={this.handleChange}
                    />
                    <div style={{ color: "red" }}>
                      {this.validator.message("name", name, "required")}
                    </div>
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group controlId="exampleForm.ControlInput1">
                    <Form.Label>Status*</Form.Label>
                    <Form.Select
                      aria-label="Default select example"
                      name="status"
                      onChange={this.handleChange}
                      value={status}
                      disabled={initialStateValue !== "Active" && status === "Deactive"}
                    >
                      <option value="">Select</option>
                      {statuses.map((singleStatus) => (
                        <option key={singleStatus.id} value={singleStatus.name}>
                          {singleStatus.name}
                        </option>
                      ))}
                    </Form.Select>
                    <div style={{ color: "red" }}>
                      {this.validator.message("status", status, "required")}
                    </div>
                    {(initialStateValue !== "Active" && status === "Deactive") && (
                      <div style={{ marginTop: '10px', fontSize: '10px' }}>
                        Can't activate a deactivated price level. Please create a new record if you need same price for same level.
                      </div>
                    )}
                  </Form.Group>
                </Col>
              </Row>
              <Row className="my-5">
                <Col md={5}>
                  <Form.Group controlId="exampleForm.ControlInput1">
                    <Form.Label>Credits*</Form.Label>
                    <Form.Control
                      type="number"
                      name="credits"
                      min="0.01"  // Minimum allowed value
                      step="any"   // Allows decimal values
                      disabled
                      value={credits === null || credits === undefined ? "" : credits}
                      placeholder="Credits"
                      onChange={this.handleChange}
                      onKeyDown={(e) => {
                        // Prevent negative numbers from being entered
                        if (e.key === '-' || e.key === 'e') {
                          e.preventDefault();
                        }
                      }}
                    />
                    <div style={{ color: "red" }}>
                      <div style={{ color: "red" }}>
                        {this.validator.message(
                          "credits", 
                          credits, 
                          ["required", "positiveNumber"]
                        )}
                      </div> 
                    </div>
                  </Form.Group>
                </Col>

                <Col md={7}>
                  <Form.Group md="12" controlId="exampleForm.ControlInput1">
                    <Form.Label>Currency Type and Value*</Form.Label>
                    <div style={{ display: 'flex', gap: '0px', alignItems: 'center' }}>
                      <Form.Select
                        id="currency_types"
                        name="currency_type"
                        value={this.state.currency_type_id}
                        onChange={this.handleChangeCurrencyType}
                        className="form-control"
                        style={{
                          borderTopRightRadius: 0,
                          borderBottomRightRadius: 0,
                          width: '25%',
                        }}
                        disabled
                      >
                        <option value="">Select</option>
                        {this.state.allCurrencyTypes.map((option) => (
                          <option key={option.currency_type_id} value={option.currency_type_id}>
                            {option.name}
                          </option>
                        ))}
                      </Form.Select>

                      <Form.Control
                        type="number"
                        name="value"
                        min="0"
                        value={value}
                        placeholder="Value"
                        onChange={this.handleChange}
                        style={{
                          borderTopLeftRadius: 0,
                          borderBottomLeftRadius: 0,
                          width: '75%',
                        }}
                        disabled
                      />
                    </div>

                    <div style={{ color: "red", marginTop: '4px' }}>
                      {this.state.valueError && <p>{this.state.valueError}</p>}
                    </div>
                  </Form.Group>

                </Col>
              </Row>

              <Row className="my-5">
                <Col md={4}>
                  <Form.Group controlId="exampleForm.ControlInput1">
                    <Form.Label>Start Date*</Form.Label>
                    <Form.Control
                      type="date"
                      name="start_date"
                      value={start_date ? this.formatDateForInput(new Date(start_date)) : ""}
                      onChange={this.handleChange}
                    />
                    <div style={{ color: "red" }}>
                      {this.validator.message("start_date", start_date, "required")}
                    </div>
                  </Form.Group>
                </Col>

                <Col md={4}>
                  <Form.Group controlId="noEndDate" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                    <Form.Label>Set end date?</Form.Label>
                    <CheckBoxInline style={{ alignItems: "center" }}>
                      <Form.Label className="mb-0 mr-1" style={{ fontWeight: "500" }}>
                        Yes
                      </Form.Label>
                      <CheckBox
                        onChange={(e) => this.noEndDateSelected(e, true)}
                        checked={noEndDate}
                      />
                      <Form.Label className="mb-0 mx-2" style={{ fontWeight: "500" }}>
                        No
                      </Form.Label>
                      <CheckBox
                        onChange={(e) => this.noEndDateSelected(e, false)}
                        checked={!noEndDate}
                      />
                    </CheckBoxInline>
                  </Form.Group>
                </Col>

                {noEndDate && (
                  <Col md={4}>
                    <Form.Group controlId="exampleForm.ControlInput1">
                      <Form.Label>End Date*</Form.Label>
                      <Form.Control
                        type="date"
                        name="end_date"
                        min={start_date}
                        value={end_date ? this.formatDateForInput(new Date(end_date)) : ""}
                        onChange={this.handleChange}
                      />
                      <div style={{ color: "red" }}>
                        {noEndDate && this.validator.message("end_date", end_date, "required")}
                      </div>
                    </Form.Group>
                  </Col>
                )}
                {this.state.dateError && (
                  <div style={{ color: "red", marginTop: '4px' }}>{this.state.dateError}</div>
                )}
              </Row>

            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="modal-btn"
              id="modal-close-button"
              style={closeBtnStyle}
              onClick={() => {
                this.setState({
                  showModal: false,
                  creditsError: "",
                  valueError: "",
                  dateError: "",
                  isModified: false,
                });
                this.validator.purgeFields();
                this.validator.hideMessages();
              }}
            >
              Close
            </Button>
            {levelPricePrivilege?.editVisibility && (
              <Button
                className="modal-btn"
                variant="primary"
                style={addBtnStyle}
                onClick={this.updateLevelPrice}
              >
                Save changes
              </Button>
            )}
          </Modal.Footer>
        </Modal>
      </>
    );
  }
}
